<template>
  <div>
    <b-form>
      <b-row class="mt-4">
        <b-col xl="3" lg="3" sm="3">
          <p class="mt-3">
            <span class="h3">GT</span>
          </p>
        </b-col>
        <b-col xl="9" lg="9" sm="9">
          <b-form-group label-for="input-1">
            <b-form-input id="input-1" v-model="form.gt" :state="gtStatus"></b-form-input>
            <b-form-invalid-feedback :state="gtStatus">
              Please enter a valid gt.
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      
      <hr>
      <div class="mt-3 d-flex justify-content-between">
        <base-button type="white" title="Close"  v-on:click="modalClose()">
          Close
        </base-button>
        <base-button type="primary" title="Save"  v-on:click="submit" :loading="submitLoading">
            Test Now
        </base-button>
      </div>
    </b-form>
  </div>
</template>

<script>
import {VueTelInput} from 'vue-tel-input';
import 'vue-tel-input/dist/vue-tel-input.css';
import productManagementService from "../../../../common/api-services/product-management-service";
import handleResponse from "@/common/directive/handlResponse";

export default {
  name: "Users-Create",
  components: {
    VueTelInput
  },
  computed: {
    gtStatus() {
      return this.form.gt !== '';
    },
  },
  data() {
    return {
      form: {
        gt: "",
      },
      submitLoading: false
    }
  },
  mounted() {

  },
  methods: {

    modalClose() {
      this.$bvModal.hide('test-nsim-gt')
    },

    async submit(){
      if (
          this.form.gt != ''
        ) {
        
        this.submitLoading = true;

        const res = await productManagementService.TestNSIMGT(this.form);
        let {type, msg} = handleResponse.apiResponse(res);
        this.$toast(msg, {type: type})
        this.modalClose();
      }
    }
  }
}
</script>
